import { createSlice } from "@reduxjs/toolkit";
import { InventoryLogResponseDto } from "../../shared/dtos/inventory/InventoryLogResponseDto";
import {
  getInitialListState,
  generateListReducers,
} from "../utils/listFactory";

const inventoryLogSlice = createSlice({
  name: "inventoryLog",
  initialState: getInitialListState<InventoryLogResponseDto>(),
  reducers: { ...generateListReducers<InventoryLogResponseDto>() },
});

export const inventoryLogActions = inventoryLogSlice.actions;
export default inventoryLogSlice.reducer;
